import { ModuleWithProviders, NgModule } from '@angular/core';
import { EmailDetailsComponent, EmailEditComponent } from '@spaq/modules/email/pages';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import { UpdateEmailComponent } from './components';

@NgModule({
	imports: [SharedCommonModule, FormModule, SharedComponentsModule, SharedFormModule],
	declarations: [EmailEditComponent, UpdateEmailComponent, EmailDetailsComponent],
	exports: [EmailEditComponent, UpdateEmailComponent, EmailDetailsComponent]
})
export class EmailModule {
	static forRoot(): ModuleWithProviders<EmailModule> {
		return {
			ngModule: EmailModule,
			providers: []
		};
	}
}
